export const routes_proveedores=[
    {
        path:'/header',
        component:()=> import('./pages/header'),
         children: [
            {
                path:'/empresas/registro',
                name:'empresa_registro',
                component:()=> import('./pages/Stepper')
            },
             {
                 path:'/empresas/registro/:id',
                 name:'empresa_registro_pre',
                 component:()=> import('./pages/Stepper')
             },
         ]
     },
     {
      path:'/empresas/index',
      name:'Inicio Fodes',
      component:()=> import('./pages/index')
     },
    {
        path:'/empresas/index/:id',
        name:'preregistro',
        component:()=> import('./pages/index')

    },
     {
      path:'/empresas/final',
      name:'Fin Fodes',
      component:()=> import('./pages/pagina_final')
    },
    {
        path:'/empresas/registros',
        name:'Registro Fodes',
        component:()=> import('./pages/registrar_proveedor')
    },
]